module.exports = __webpack_public_path__ + "static/media/denied.c735c1a1.svg";